import { selectAccessStylistId } from 'selectors/access.selectors';
import { selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import { selectPinUserIsPrimary, selectUserStylistId } from 'selectors/simple';
import asArray from 'utils/arrays/asArray.util';
import { selectCognitoAttributes } from 'utils/cognito.util';
import { isValidId } from 'utils/predicates/fields.util';
import equalStrings from 'utils/strings/equalStrings.util';

export const selectLoggedInStylistId = (state) => {
  const accessStylistId = selectAccessStylistId(state);
  if (isValidId(accessStylistId)) return accessStylistId;

  const libStylistId = selectUserStylistId(state);
  if (isValidId(libStylistId)) return libStylistId;

  if (selectPinUserIsPrimary(state) !== true) return null;

  const { email } = selectCognitoAttributes(state) ?? {};
  if (!email) return null;

  const stylists = asArray(selectCurrentSalonStylists(state));
  const match = stylists.find((stylist) => equalStrings(stylist?.email, email));

  return match?.id ?? null;
};
